import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { transportAdminAPI } from '../../services/api';

export default function SuperTransportPaymentsPage() {
  const [orders, setOrders]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [acting, setActing]   = useState(null);

  const [bankAccounts, setBankAccounts]   = useState([]);
  const [bankLoading, setBankLoading]     = useState(true);
  const [newBank, setNewBank]             = useState({ bankName: '', accountNumber: '', accountHolder: '' });
  const [savingBank, setSavingBank]       = useState(false);

  const load = () => {
    setLoading(true);
    transportAdminAPI.listPendingPayments()
      .then((res) => setOrders(res.data.data || []))
      .catch(() => toast.error('خطأ في تحميل الطلبات'))
      .finally(() => setLoading(false));
  };

  const loadBankAccounts = () => {
    setBankLoading(true);
    transportAdminAPI.listBankAccounts()
      .then((res) => setBankAccounts(res.data.data || []))
      .catch(() => toast.error('خطأ في تحميل الحسابات البنكية'))
      .finally(() => setBankLoading(false));
  };

  useEffect(() => { load(); loadBankAccounts(); }, []);

  const addBankAccount = async () => {
    if (!newBank.bankName || !newBank.accountNumber || !newBank.accountHolder) {
      toast.error('يرجى تعبئة جميع الحقول');
      return;
    }
    setSavingBank(true);
    try {
      await transportAdminAPI.createBankAccount(newBank);
      toast.success('تمت إضافة الحساب البنكي');
      setNewBank({ bankName: '', accountNumber: '', accountHolder: '' });
      loadBankAccounts();
    } catch (e) { toast.error(e.response?.data?.message || 'خطأ'); }
    finally { setSavingBank(false); }
  };

  const toggleBankAccount = async (account) => {
    try {
      await transportAdminAPI.updateBankAccount(account.id, { isActive: !account.isActive });
      loadBankAccounts();
    } catch (e) { toast.error(e.response?.data?.message || 'خطأ'); }
  };

  const removeBankAccount = async (id) => {
    if (!window.confirm('حذف هذا الحساب البنكي؟')) return;
    try {
      await transportAdminAPI.deleteBankAccount(id);
      toast.success('تم الحذف');
      loadBankAccounts();
    } catch (e) { toast.error(e.response?.data?.message || 'خطأ'); }
  };

  const confirm = async (id) => {
    setActing(id);
    try {
      await transportAdminAPI.confirmPayment(id);
      toast.success('تم تأكيد الدفع');
      load();
    } catch (e) { toast.error(e.response?.data?.message || 'خطأ'); }
    finally { setActing(null); }
  };

  const reject = async (id) => {
    const reason = window.prompt('سبب الرفض (اختياري):') || '';
    setActing(id);
    try {
      await transportAdminAPI.rejectPayment(id, reason);
      toast.success('تم رفض الدفع');
      load();
    } catch (e) { toast.error(e.response?.data?.message || 'خطأ'); }
    finally { setActing(null); }
  };

  return (
    <div dir="rtl" className="p-4 md:p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-1">💳 مراجعة دفعات النقل</h1>
      <p className="text-sm text-gray-500 mb-6">إيصالات دفع طلبات سوق نقل البضائع بانتظار المراجعة</p>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5 mb-8">
        <h2 className="font-bold text-gray-800 mb-1">🏦 الحسابات البنكية لطلبات النقل العام</h2>
        <p className="text-xs text-gray-500 mb-4">
          تظهر هذه الحسابات للعميل عند دفع طلب نقل بضائع (نقل عام) — غير مرتبطة بأي شركة حافلات.
        </p>

        {bankLoading ? (
          <div className="text-center py-6 text-gray-400 text-sm">جاري التحميل...</div>
        ) : (
          <div className="space-y-2 mb-4">
            {bankAccounts.length === 0 && (
              <p className="text-sm text-gray-400">لا توجد حسابات بنكية بعد</p>
            )}
            {bankAccounts.map((b) => (
              <div key={b.id} className={`flex items-center gap-3 p-3 rounded-xl border ${b.isActive ? 'border-gray-100 bg-gray-50' : 'border-gray-100 bg-gray-100 opacity-60'}`}>
                <div className="flex-1">
                  <p className="font-bold text-sm text-gray-800">{b.bankName}</p>
                  <p className="text-xs text-gray-500">{b.accountNumber} — {b.accountHolder}</p>
                </div>
                <button onClick={() => toggleBankAccount(b)}
                  className={`text-xs font-bold px-3 py-1.5 rounded-lg ${b.isActive ? 'bg-emerald-50 text-emerald-700 hover:bg-emerald-100' : 'bg-gray-200 text-gray-600 hover:bg-gray-300'}`}>
                  {b.isActive ? 'مفعّل' : 'معطّل'}
                </button>
                <button onClick={() => removeBankAccount(b.id)}
                  className="text-xs font-bold px-3 py-1.5 rounded-lg bg-red-50 text-red-700 hover:bg-red-100">
                  حذف
                </button>
              </div>
            ))}
          </div>
        )}

        <div className="flex flex-col sm:flex-row gap-2 pt-3 border-t border-gray-100">
          <input value={newBank.bankName} onChange={(e) => setNewBank({ ...newBank, bankName: e.target.value })}
            placeholder="اسم البنك" className="flex-1 border border-gray-200 rounded-lg px-3 py-2 text-sm" />
          <input value={newBank.accountNumber} onChange={(e) => setNewBank({ ...newBank, accountNumber: e.target.value })}
            placeholder="رقم الحساب" className="flex-1 border border-gray-200 rounded-lg px-3 py-2 text-sm" />
          <input value={newBank.accountHolder} onChange={(e) => setNewBank({ ...newBank, accountHolder: e.target.value })}
            placeholder="اسم صاحب الحساب" className="flex-1 border border-gray-200 rounded-lg px-3 py-2 text-sm" />
          <button onClick={addBankAccount} disabled={savingBank}
            className="bg-blue-700 hover:bg-blue-800 disabled:opacity-50 text-white text-sm font-bold px-4 py-2 rounded-lg transition">
            {savingBank ? '...' : '+ إضافة'}
          </button>
        </div>
      </div>

      {loading ? (
        <div className="text-center py-16 text-gray-400">جاري التحميل...</div>
      ) : orders.length === 0 ? (
        <div className="text-center py-16 text-gray-400">لا توجد إيصالات بانتظار المراجعة</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {orders.map((o) => (
            <div key={o.id} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
              <p className="font-mono text-xs text-gray-400 mb-1">{o.orderNumber}</p>
              <p className="font-bold text-gray-800 mb-1">{o.provider?.name}</p>
              <p className="text-lg font-black text-blue-700 mb-3">{o.price} ج.س</p>
              {o.paymentProofUrl && (
                <a href={o.paymentProofUrl} target="_blank" rel="noopener noreferrer" className="text-xs text-blue-600 hover:underline block mb-3">
                  عرض إيصال الدفع
                </a>
              )}
              <div className="flex gap-2">
                <button onClick={() => confirm(o.id)} disabled={acting === o.id}
                  className="flex-1 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 text-white text-xs font-bold py-2 rounded-lg transition">
                  تأكيد
                </button>
                <button onClick={() => reject(o.id)} disabled={acting === o.id}
                  className="flex-1 bg-red-50 hover:bg-red-100 disabled:opacity-50 text-red-700 border border-red-200 text-xs font-bold py-2 rounded-lg transition">
                  رفض
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
